import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getCartSaved } from '../../../store/cart-v2/valorized/actionsToDo'
import { CartComponent } from './mixins'
import { getCurrency } from '../../../store/currency/actionsTodo'
import { ID_PAIS } from '../../../constants'
import CartHeader from './components/CartHeader/index'
import { getCouponCode } from '../../../store/coupon/actionsToDo'
import CartSection from './cartSection'
import { AppStore } from '../../../store'
import { CouponState } from '../../../store/coupon/types'
import { CurrencyState } from '../../../store/currency/types'
import path from '../../../routesCustom'
import { closeCart } from '../../../store/cart-v2/modal/actionsToDo'
import { setDataCvCompra } from '../../../store/ecommerce/by-consumo-credito/actionsToDo'
import { showPageDatosFacturacionCliente } from '../../../store/ecommerce/datos-facturacion/actionsToDo'
import cartService from '../../../services/cart-service'
import { useCurrentUser } from '../../../hooks/current-user-hook'

const Component = ({ isOpened }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { fetchCoupon } = useSelector<AppStore, CouponState>(({ couponStore }) => couponStore)
  const { idPais } = useSelector<AppStore, CurrencyState>(({ currencyStore }) => currencyStore)
  const { userData } = useCurrentUser()

  const generateAbandonedCartEvent = () => {
    if (userData) {
      const { idUsuario, mailEmpresa, nombreUsuario, apellidoUsuario } = userData
      const data = {
        companyUserEmail: mailEmpresa,
        companyUserId: idUsuario,
        companyUserLastName: apellidoUsuario,
        companyUserName: nombreUsuario,
        countryId: ID_PAIS,
      }
      cartService.generateAbandonedCartEvent(data)
    }
  }
  const onClickHandler = () => {
    generateAbandonedCartEvent()
    const cvId = history?.location?.state?.cvId
    dispatch(closeCart())
    dispatch(showPageDatosFacturacionCliente())
    if (cvId) {
      dispatch(
        setDataCvCompra({
          cvId,
        })
      )
    }

    history.push(path.privatePath.DATOS_FACTURACION)
  }

  const getCoupon = useCallback(() => dispatch(getCouponCode({ isFixed: true })), [])

  useEffect(() => {
    idPais.length === 0 && dispatch(getCurrency(ID_PAIS)) /** para alguna metrica */
    !fetchCoupon.couponCode && getCoupon()
    dispatch(getCartSaved())
  }, [])

  return (
    <CartComponent isOpened={isOpened}>
      <CartHeader />
      <CartSection onClickHandler={onClickHandler} />
    </CartComponent>
  )
}

export default Component
